import * as fetchServiceRequests from "./fetchServiceRequests";
import * as serviceRequest from "./serviceRequest";
import * as serviceRequestUpdates from "./serviceRequestUpdates";
import * as fetchServiceRequestUpdates from "./fetchServiceRequestUpdates";
import { initialState as fetchServiceRequestInitialState, FetchServiceRequestState } from "./fetchServiceRequests";
import { initialState as serviceRequestInitialState, ServiceRequestState } from "./serviceRequest";
import { initialState as serviceRequestUpdatesInitialState, ServiceRequestUpdatesState } from "./serviceRequestUpdates";
import { initialState as fetchServiceRequestUpdatesInitialState, FetchServiceRequestUpdatesState } from "./fetchServiceRequestUpdates";
import reduceReducers from "reduce-reducers";


export const Types: { [key: string]: any } = {
    ...fetchServiceRequests.Types,
    ...serviceRequest.Types,
    ...serviceRequestUpdates.Types,
    ...fetchServiceRequestUpdates.Types
};

export const Actions: { fetch: typeof fetchServiceRequests.Actions, serviceRequest: typeof serviceRequest.Actions, serviceRequestUpdates: typeof serviceRequestUpdates.Actions, fetchServiceRequestUpdates: typeof fetchServiceRequestUpdates.Actions } = {
    fetch: fetchServiceRequests.Actions,
    serviceRequest: serviceRequest.Actions,
    serviceRequestUpdates: serviceRequestUpdates.Actions,
    fetchServiceRequestUpdates: fetchServiceRequestUpdates.Actions
};

export const fetchServiceRequestReducer = reduceReducers<FetchServiceRequestState>(
    fetchServiceRequestInitialState,
    fetchServiceRequests.default as any
);

export const addServiceRequestReducer: (state: ServiceRequestState, action: any) => ServiceRequestState = reduceReducers<ServiceRequestState>(
    serviceRequestInitialState,
    serviceRequest.default as any
);

export const serviceRequestUpdatesReducer: (state: ServiceRequestUpdatesState, action: any) => ServiceRequestUpdatesState = reduceReducers<ServiceRequestUpdatesState>(
    serviceRequestUpdatesInitialState,
    serviceRequestUpdates.default as any
);

export const fetchServiceRequestUpdatesReducer = reduceReducers<FetchServiceRequestUpdatesState>(
    fetchServiceRequestUpdatesInitialState,
    fetchServiceRequestUpdates.default as any
);

export default {
    fetchServiceRequests: fetchServiceRequestReducer,
    serviceRequest: addServiceRequestReducer,
    serviceRequestUpdates: serviceRequestUpdatesReducer,
    fetchServiceRequestUpdates: fetchServiceRequestUpdatesReducer
};